module.exports = __webpack_public_path__ + "img/Rucksack.e60ddcc6.png";